// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global vont:false, wc_checkout_params:false, google */

(($) => {
    const wntrTheme = {
        window: $(window),
        body: $('body'),
        html: $('html'),
        document: $(document),
        resizeListener: null,

        /**
         * Initialise theme JS on page load
         */
        init: () => {
            wntrTheme.html.removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Tryhard sticky header that disappears when scrolling down and shows when scrolling up.
         */
        __hideNavOnScroll: function() {

            const header = wntrTheme.body.find('.header__mobile');

            wntrTheme.window.scroll(function(event) {
                scrollFunction(event);
            });

            wntrTheme.window.on('load', function(evt) {
                wntrTheme.startTime = evt.timeStamp;
            });

            let lastScrollTop = 0;
            const scrollFunction = function(evt) {
                if(!wntrTheme.startTime || evt.timeStamp - wntrTheme.startTime < 50) {
                    return;
                } else {
                    const st = $(this).scrollTop();
                    if(st > 50) {
                        if(st > lastScrollTop) {
                            // downscroll code
                            header.addClass('nav-up');
                            wntrTheme.body.addClass('header-nav-up');
                        } else {
                            // upscroll code
                            header.removeClass('nav-up');
                            wntrTheme.body.removeClass('header-nav-up');
                        }
                    }

                    lastScrollTop = st;
                }
            };
        },

        /**
         * Handle variation radio buttons
         */
        __handleVariationRadioButtons: function() {
            const variation_radios = wntrTheme.body.find('.variation-radios input');
            const variation_predefiend_quantities = wntrTheme.body.find('.custom-product-qty');

            // If we have a query param, dont select anything
            if(variation_radios.length > 0 && window.location.href.indexOf('attribute_') !== -1) {
                variation_radios.each(function() {
                    $(this).prop('checked', false);
                });
            }

            // If variable product and is selected, enabble add to cart button
            if(variation_radios.length > 0 && variation_radios.is(':checked')) {
                if(variation_predefiend_quantities.length > 0) {
                    // Calc price
                    calcPrice(wntrTheme.body.find('.variation-radios input:checked'));
                    // Show predefined variations
                    variation_predefiend_quantities.css('display', 'flex');
                    wntrTheme.body.find('.single_add_to_cart_button').text(vont['add-to-cart-text']).css('max-width', '30rem');
                } else {
                    wntrTheme.body.find('.single_add_to_cart_button').prop("disabled", false);
                    wntrTheme.body.find('.single_add_to_cart_button').removeAttr("disabled");
                    wntrTheme.body.find('.single_add_to_cart_button').text(vont['add-to-cart-text']).css('max-width', '30rem');
                }
            }

            $(document).on('change', '.variation-radios input', function() {
                $('.variation-radios input:checked').each(function(index, element) {
                    const $el = $(element);
                    const thisName = $el.attr('name');
                    const thisVal = $el.attr('value');

                    // Change hidden select to given variation and trigger change
                    $('select[name="' + thisName + '"]').val(thisVal).trigger('change');
                    wntrTheme.body.find('.single_add_to_cart_button').text(vont['add-to-cart-text']).css('max-width', '30rem');

                    // Enable button if predefined quantites are disabled
                    if(variation_predefiend_quantities.length <= 0) {
                        wntrTheme.body.find('.single_add_to_cart_button').prop("disabled", false);
                        wntrTheme.body.find('.single_add_to_cart_button').removeAttr("disabled");
                    } else {
                        // Calc price
                        calcPrice($el);
                        // Show predefined variations
                        variation_predefiend_quantities.css('display', 'flex');
                    }
                });
            });

            $(document).on('change', '.custom-product-qty input', function() {
                const $el = $(this);
                const thisVal = $el.attr('value');

                // Change hidden quantity input to given quantity and trigger change
                $('input[name="quantity"]').val(thisVal).trigger('change');

                wntrTheme.body.find('.single_add_to_cart_button').prop("disabled", false);
                wntrTheme.body.find('.single_add_to_cart_button').removeAttr("disabled");
            });

            // Handle updated variation values
            $(document).on('woocommerce_update_variation_values', function() {
                $('.variation-radios input').each(function(index, element) {
                    const $el = $(element);
                    const thisName = $el.attr('name');
                    const thisVal = $el.attr('value');
                    $el.removeAttr('disabled');
                    if($('select[name="' + thisName + '"] option[value="' + thisVal + '"]').is(':disabled')) {
                        $el.prop('disabled', true);
                    }
                });
            });
            function roundToTwo(num) {
                return +(Math.round(num + "e+2")  + "e-2");
            }

            function calcPrice($el) {
                const display_price = $el.data('price');
                wntrTheme.body.find('.custom-product-qty input').each(function() {
                    const html = document.getElementsByTagName("html")[0].getAttribute("lang");

                    if(html === 'sv-SE') {
                        const quantity = $(this).attr('value');
                        const discount = wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__price').data('discount');
                        const price = Math.round(Math.round(display_price * (1 - discount)) * quantity);

                        wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__price').html(price + ' kr');
                        if(wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__discount').length > 0) {
                            wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__discount').html('(' + Math.round(display_price * (1 - discount)) + ' kr/st)');
                        }
                    }
                    if(html === 'en-GB') {
                        const quantity = $(this).attr('value');
                        const discount = wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__price').data('discount');
                        const price = parseFloat(display_price * (1 - discount) * quantity).toFixed(2);

                        wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__price').html('£ ' + price);
                        if(wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__discount').length > 0) {
                            wntrTheme.body.find('label[for=' + $(this).attr('id') + '] .custom-product-qty__discount').html('(' + '£ ' + roundToTwo(display_price * (1 - discount)).toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2}) + ' /qty)');
                        }
                    }
                });
            }
        },

        __movePdpProductInformation: function() {
            let resizeTimer;
            $(window).on('resize', function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    if($(window).width() >= 1024) {
                        toggleDesktopMode();
                    } else {
                        toggleMobileMode();
                    }
                }, 250);
            });

            function toggleDesktopMode() {
                const productInformation = $('.single-product .product__information-excerpt');
                const productFaq = $('.single-product .FAQs');

                if(productFaq.length > 0) {
                    $('.single-product .woocommerce-product-gallery__wrapper').after(productFaq);
                    productFaq.css('opacity', 1);
                }
                if(productInformation.length > 0) {
                    $('.single-product .woocommerce-product-gallery__wrapper').after(productInformation);
                    productInformation.css('opacity', 1);
                }
            }

            function toggleMobileMode() {
                const productInformation = $('.single-product .product__information-excerpt');
                const productFaq = $('.single-product .FAQs');

                if(productInformation.length > 0) {
                    $('.single-product .cart').after(productInformation);
                }
                if(productFaq.length > 0) {
                    $('.single-product .product__details').after(productFaq);
                }
            }
        },

        __initSlick: function() {
            $('.featured-products__wrap').slick({
                arrows: false,
                dots: false,
                mobileFirst: true,
                slidesToShow: 2,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                        }
                    }

                ]
            });

            this.window.innerWidth < 1024 ? $('.hide-mobile').remove() : '';

            wntrTheme.body.find('.single-product-gallery').slick({
                arrows: false,
                dots: true,
                slidesToShow: 1,
                infinite: true,
            });

            wntrTheme.body.find('.product__recommendations ul.products').slick({
                slidesToShow: 5,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 2.3,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false,
                            arrows: true
                        }
                    }
                ]
            });

            $('.featured-products__wrapper').slick({
                arrows: true,
                dots: false,
                mobileFirst: true,
                slidesToShow: 2,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 5,
                            arrows: false,
                        }
                    }
                ]
            });
        },

        /**
         * Initialize video banner
         */
        __initVideoBanner: function() {
            const video = wntrTheme.body.find('.image_text_column--video');
            if(video.length) {
                $('.video-background').find('video').attr('playsinline', true);
                $('.video-background').find('video').get(0).play();
            }
        },

        __initShopClasses: function() {
            wntrTheme.body.find('.products__top-wrapper .compact').addClass('is-active');
            wntrTheme.body.find('.products').addClass('compact');
        },

        __handleMessagebarPadding: function() {
            if(wntrTheme.body.find('.image_text_column--video').length) {
                wntrTheme.body.find('.page-section-image_text_column').addClass('page-section-image_text_column--video');
            }

        },

        /**
         * Init Google Maps
         */
        __initGoogleMaps: function() {
            const map_wrapper = wntrTheme.body.find('.store-location-map');

            if(map_wrapper.length > 0) {
                $.each(map_wrapper, function() {
                    const el = $(this);
                    const locations = el.data('markers');

                    const map = new google.maps.Map(el[0], {
                        zoom: el.data('is-single') === 'yes' ? 12 : 4,
                        center: el.data('is-single') === 'yes' ? new google.maps.LatLng(locations[0]['lat'], locations[0]['lng']) : new google.maps.LatLng(62.20651, 19.53369),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        gestureHandling: 'cooperative',
                        styles: [
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#e9e9e9"
                                    },
                                    {
                                        "lightness": 17
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#f5f5f5"
                                    },
                                    {
                                        "lightness": 20
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 17
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 29
                                    },
                                    {
                                        "weight": 0.2
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 18
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#f5f5f5"
                                    },
                                    {
                                        "lightness": 21
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#dedede"
                                    },
                                    {
                                        "lightness": 21
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "saturation": 36
                                    },
                                    {
                                        "color": "#333333"
                                    },
                                    {
                                        "lightness": 40
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#f2f2f2"
                                    },
                                    {
                                        "lightness": 19
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#fefefe"
                                    },
                                    {
                                        "lightness": 20
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#fefefe"
                                    },
                                    {
                                        "lightness": 17
                                    },
                                    {
                                        "weight": 1.2
                                    }
                                ]
                            }
                        ]

                    });

                    const infowindow = new google.maps.InfoWindow();
                    const markers = [];

                    const iconMarker = {
                        url: el.data('marker-url'),
                        size: new google.maps.Size(36, 36),
                        scaledSize: new google.maps.Size(36, 36)
                    };

                    const iconBullet = {
                        url: el.data('bullet-url'),
                        size: new google.maps.Size(12, 12),
                        scaledSize: new google.maps.Size(12, 12)
                    };

                    let marker;
                    let i;

                    for(i = 0; i < locations.length; i++) {
                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
                            map: map,
                            animation: google.maps.Animation.DROP
                        });

                        marker.setIcon(iconBullet);

                        google.maps.event.addListener(marker, 'click', (function(marker, i) {
                            return function() {
                                infowindow.setContent(
                                    '<div class="store-locator__info">' +
                                    '<h2 class="store-locator__info-title">' +
                                    locations[i]['title'] +
                                    '</h2>' +
                                    '<div class="store-locator__info-address">' +
                                    locations[i]['address'] +
                                    '</div>' +
                                    '<div class="store-locator__info-opening-hours">' +
                                    locations[i]['opening-hours'] +
                                    '</div>' +
                                    '<div class="store-locator__info-route">' +
                                    '<a href="https://www.google.com/maps?saddr=My+Location&daddr=' + locations[i]['lat'] + ',' + locations[i]['lng'] + '" target="_blank" rel="noopener norefferer">' +
                                    el.data('route-label') +
                                    '</a>' +
                                    '</div>' +
                                    '</div>'
                                );
                                infowindow.open(map, marker);
                            };
                        })(marker, i));

                        markers.push(marker);
                    }

                    let zoomLevel = 1;
                    google.maps.event.addListener(map, 'zoom_changed', function() {
                        let i;
                        let prevZoomLevel = 0;

                        prevZoomLevel = zoomLevel;

                        map.getZoom() < 10 ? zoomLevel = 1 : zoomLevel = 2;

                        if(prevZoomLevel !== zoomLevel) {
                            for(i = 0; i < markers.length; i++) {
                                if(zoomLevel === 2) {
                                    markers[i].setIcon(iconMarker);
                                } else {
                                    markers[i].setIcon(iconBullet);
                                }
                            }
                        }
                    });

                    wntrTheme.body.on('click', '.store-location__locate', function() {
                        const el = $(this);
                        el.addClass('is-loading');

                        if(navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition((position) => {
                                const latitude = position.coords.latitude;
                                const longitude = position.coords.longitude;
                                const geolocpoint = new google.maps.LatLng(latitude, longitude);

                                map.setCenter(geolocpoint);
                                map.setZoom(15);

                                el.removeClass('is-loading');
                            },
                            () => {
                                handleLocationError(true, map, map.getCenter(), el);
                            });
                        } else {
                            handleLocationError(false, map, map.getCenter(), el);
                        }
                    });

                    const store_location_search = document.getElementById('store-location__search');

                    /*const searchBox = new google.maps.places.SearchBox(store_location_search, {});
                    searchBox.addListener('places_changed', function() {
                        const places = searchBox.getPlaces();

                        map.setCenter(places[0].geometry.location);
                        map.setZoom(14);
                    });*/

                    const autocomplete = initAutocomplete(store_location_search);

                    google.maps.event.addListener(autocomplete, 'place_changed', function() {
                        const place = autocomplete.getPlace();

                        map.setCenter(place.geometry.location);
                        map.setZoom(14);
                    });
                });
            }

            function initAutocomplete(input) {
                const options = {
                    types: ['(cities)'],
                    componentRestrictions: { country: 'SE' }
                };

                return new google.maps.places.Autocomplete(input, options);
            }

            function handleLocationError(browserHasGeolocation, map, pos, button) {
                map.setCenter(pos);
                $.alert({
                    title: 'Fel!    ',
                    content: (browserHasGeolocation ? 'Vi kunde inte hitta din position.' : 'Din webbläsare stöder inte tekniken som behövs för att hitta din position.'),
                });

                button.removeClass('is-loading');
            }
        },

        __toggleOrderReview: () => {
            wntrTheme.body.on('click', '.cart__toggle-order-review', function() {
                if(wntrTheme.body.find('.cart-container').hasClass('is--active')) {
                    $(this).find('.cart__toggle-order-review-label').text('Show order summary');
                    wntrTheme.body.find('.cart-container').removeClass('is--active');
                    wntrTheme.body.find('.woocommerce-checkout-coupon-wrapper').removeClass('is--active');
                } else {
                    $(this).find('.cart__toggle-order-review-label').text('Hide order summary');
                    wntrTheme.body.find('.cart-container').addClass('is--active');
                    wntrTheme.body.find('.woocommerce-checkout-coupon-wrapper').addClass('is--active');
                }
            });

            $(document.body).on('updated_cart_totals', function() {
                wntrTheme.body.find('.woocommerce-checkout-coupon-wrapper').removeClass('is--active');
            });
        },

        /**
         * Toogle mini cart
         */
        __toggleMiniCart: () => {
            const mini_cart = wntrTheme.body.find(('.mini__cart'));

            wntrTheme.body.on('click', '.mini__cart-toggle-open', function() {
                wntrTheme.body.addClass('mini__cart--open');

                setTimeout(function() {
                    mini_cart.css('width', '79.99999%');
                    setTimeout(function() {
                        mini_cart.css('width', '80%');
                    }, 1);
                }, 500);
            });

            wntrTheme.body.on('click', '.mini__cart-toggle-close', function() {
                wntrTheme.body.removeClass('mini__cart--open');
            });

            wntrTheme.body.on('click', '.mini__cart-overlay', function() {
                wntrTheme.body.removeClass('mini__cart--open');
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && wntrTheme.body.hasClass('mini__cart--open')) {
                    wntrTheme.body.removeClass('mini__cart--open');
                }
            });
        },

        /**
         * Toggle menu on click for mobile and on hover for desktop
         */
        __toggleMainMenu: () => {
            const main_menu = wntrTheme.body.find('.header__navbar-secondary');

            if(window.innerWidth < 1024) {
                wntrTheme.body.find('.main-menu-toggle--close').on('click', function() {
                    wntrTheme.body.removeClass('main-menu-open');
                });
                wntrTheme.body.on('click', '.main__menu-overlay', function() {
                    wntrTheme.body.removeClass('main-menu-open');
                });

                wntrTheme.body.find('.menu-item').closest('.shop-link').on('click', function(e) {
                    e.preventDefault();
                    wntrTheme.body.addClass('desktop-menu-open');
                });

                wntrTheme.body.find('.header__shop-link').on('click', function(e) {
                    e.preventDefault();
                    wntrTheme.body.addClass('main-menu-open');

                    setTimeout(function() {
                        main_menu.css('width', '79.99999%');
                        setTimeout(function() {
                            main_menu.css('width', '80%');
                        }, 1);
                    }, 500);
                });

            } else {

                wntrTheme.body.find('.menu-item').closest('.shop-link').on('mouseenter', function() {
                    wntrTheme.body.addClass('desktop-menu-open');
                });

                wntrTheme.body.find('.header__shop-link').on('mouseenter', function() {
                    wntrTheme.body.addClass('main-menu-open');

                    setTimeout(function() {
                        main_menu.css('width', '79.99999%');
                        setTimeout(function() {
                            main_menu.css('width', '80%');
                        }, 1);
                    }, 500);
                });

                wntrTheme.body.find('.header__navbar-secondary').on('mouseleave', function() {
                    wntrTheme.body.removeClass('main-menu-open');
                });

                wntrTheme.body.find('.header__menu').on('mouseleave', function() {
                    wntrTheme.body.removeClass('desktop-menu-open');
                });
                $(document).keyup(function(e) {
                    if(e.keyCode === 27 && wntrTheme.body.hasClass('main-menu-open')) {
                        wntrTheme.body.removeClass('main-menu-open');
                    }
                });
            }
        },

        __toggleMobileSliders: function() {
            if(wntrTheme.window.width() < 720) {
                wntrTheme.body.find('.footer__about').on('click', (e) => {
                    $(e.currentTarget).toggleClass('is-active');
                });
                wntrTheme.body.find('.footer__support').on('click', () => {
                    wntrTheme.body.find('.footer__support').toggleClass('is-active');
                });
            }
        },

        __toggleProductspecificationSlider: function() {
            wntrTheme.body.on('click', '.product__information__title', function() {
                wntrTheme.body.find('.product__information-specification-content').toggleClass('is-active');
            });
        },

        __handleCurrencyLanguageModal: function() {
            wntrTheme.body.find('.modal__action--close').on('click', () => {
                wntrTheme.body.find('.modal').toggleClass('is-active');
                wntrTheme.body.removeClass('is-active');
            });
            wntrTheme.body.find('.modal__action--save').on('click', () => {
                wntrTheme.body.find('.modal').removeClass('is-active');
                wntrTheme.body.removeClass('is-active');
            });
            wntrTheme.body.find('.footer__language-modal').on('click', () => {
                wntrTheme.body.find('.modal').addClass('is-active');
                wntrTheme.body.addClass('is-active');
            });
            wntrTheme.document.keyup(function(e) {
                if(e.keyCode === 27 && wntrTheme.body.find('.modal').hasClass('is-active')) {
                    wntrTheme.body.find('.modal').removeClass('is-active');
                    wntrTheme.body.removeClass('is-active');
                }
            });
        },

        __handleDisclaimer: function() {
            const disclaimer = wntrTheme.body.find('.disclaimer');
            if(disclaimer.length > 0) {
                // Check if the user have accepted the disclaimer
                if(getCookie('_vont_disclaimer')) {
                    disclaimer.remove();
                } else {
                    // Show disclaimer
                    disclaimer.addClass('disclaimer-not-accepted');
                    wntrTheme.body.addClass('disclaimer-not-accepted');
                    wntrTheme.body.find('.disclaimer__action--agree').on('click', () => {
                        setCookie('_vont_disclaimer', 'true', 100);
                        disclaimer.remove();
                        wntrTheme.body.removeClass('disclaimer-not-accepted');
                    });
                    wntrTheme.body.find('.disclaimer__action--disagree').on('click', () => {
                        window.location.href = 'https://www.google.se';
                    });
                }
            }

            function setCookie(cname, cvalue, exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                const expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }

            function getCookie(cname) {
                const name = cname + "=";
                const decodedCookie = decodeURIComponent(document.cookie);
                const ca = decodedCookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while(c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if(c.indexOf(name) === 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }
        },

        __toggleFaqSlider: function() {
            wntrTheme.body.find('.FAQ__top').on('click', (e) => {
                $(e.currentTarget).parent().toggleClass('is-active');
            });
        },

        __languageCurrencySwitcher: function() {
            wntrTheme.body.on('click', '#language-switcher-apply-btn', function() {
                const modal = $('#languages-currencies');
                //const form = modal.find('.currency_switch_form');

                //form.attr('action', modal.find('.languages__currencies-language-switcher').find(':selected').data('url'));

                //form.submit();

                //console.log(modal);

                window.location.href = modal.find('.languages__currencies-language-switcher').find(':selected').data('url');
            });
        },

        __toggleCompactOrExpanded: function() {
            wntrTheme.body.find('.products__top-wrapper .compact').on('click', function() {
                if(!$(this).hasClass('is-active')) {
                    wntrTheme.body.find('.products').removeClass('expanded');
                    wntrTheme.body.find('.products__top-wrapper button').removeClass('is-active');
                    $(this).addClass('is-active');
                    wntrTheme.body.find('.products').addClass('compact');
                }
            });
            wntrTheme.body.find('.products__top-wrapper .expanded').on('click', function() {
                if(!$(this).hasClass('is-active')) {
                    wntrTheme.body.find('.products').removeClass('compact');
                    wntrTheme.body.find('.products__top-wrapper button').removeClass('is-active');
                    $(this).addClass('is-active');
                    wntrTheme.body.find('.products').addClass('expanded');
                }
            });
        },

        /**
         * CUSTOM TWENTIES CHECKOUT
         */
        __cart: () => {
            if(wntrTheme.body.hasClass('woocommerce-cart') || wntrTheme.body.hasClass('woocommerce-checkout')) {
                // Change quantity
                wntrTheme.body.on('change', '.product-quantity select, .product-quantity input', function() {
                    wntrTheme.body.find('.update-cart-btn').trigger('click');
                });

                wntrTheme.body.on('click', '.cart-toggle-coupon', function() {
                    $(this).parent().find('.coupon').slideToggle().find('input').focus();
                });

                // Submit cart (checkout step 1)
                wntrTheme.body.on('submit', '.woocommerce-checkout-step-1', function(e) {
                    e.preventDefault();

                    const form = $(this);

                    form.block({
                        message: null,
                        overlayCSS: wntrTheme.overlayCss
                    });

                    const shipping_country_val = form.find('#calc_shipping_country').val();
                    if(shipping_country_val === 'SE') {
                        form.append('<input type="hidden" value="SEK" name="aelia_cs_currency" />');
                    } else if(shipping_country_val === 'NO') {
                        form.append('<input type="hidden" value="NOK" name="aelia_cs_currency" />');
                    } else if(shipping_country_val === 'DK') {
                        form.append('<input type="hidden" value="DKK" name="aelia_cs_currency" />');
                    } else if(shipping_country_val === 'FI') {
                        form.append('<input type="hidden" value="EUR" name="aelia_cs_currency" />');
                    }

                    $.ajax({
                        type: form.attr('method'),
                        url: form.attr('action'),
                        data: form.serialize(),
                        dataType: 'html',
                        complete: function() {
                            window.location.href = vont['checkout-url'];
                        }
                    });
                });
            }
        },

        __checkout: () => {
            if(wntrTheme.body.find('.woocommerce-checkout').length > 0) {
                const checkout = wntrTheme.body.find('.woocommerce-checkout');

                // Ensure billing country isn't changed when browser autofills address,
                // while still keeping the select enabled so it's sent in to the backend
                checkout.find('#billing_country, #shipping_country').attr('autocomplete', 'new-password');
                checkout.find('#billing_country option:not(:selected), #shipping_country option:not(:selected)').prop('disabled', true);

                // Prevent autofill of hidden email field. Email was set on step 1.
                checkout.find('#billing_email').attr('autocomplete', 'new-password');

                const checkIfCanChooseShippingMethod = function() {
                    if(checkout.find('.woocommerce-shipping-totals input[id*="flexible_shipping"]').length === 0) {
                        checkout.find('.checkout__shipping-method-table').show();
                        checkout.find('.checkout__shipping-not-available').hide();
                        return;
                    }

                    if(
                        (!checkout.find('#ship-to-different-address-checkbox').is(':checked') && checkout.find('#billing_address_1').val() && checkout.find('#billing_postcode').val() && checkout.find('#billing_city').val()) ||
                        (checkout.find('#ship-to-different-address-checkbox').is(':checked') && checkout.find('#shipping_address_1').val() && checkout.find('#shipping_postcode').val() && checkout.find('#shipping_city').val())
                    ) {
                        checkout.find('.checkout__shipping-method-table').show();
                        checkout.find('.checkout__shipping-not-available').hide();
                    } else {
                        checkout.find('.checkout__shipping-method-table').hide();
                        checkout.find('.checkout__shipping-not-available').show();
                    }
                };

                wntrTheme.body.on('change', '.woocommerce-billing-fields input, .woocommerce-billing-fields select, .woocommerce-shipping-fields input, .woocommerce-shipping-fields select', function() {
                    checkIfCanChooseShippingMethod();
                });

                wntrTheme.body.on('update_checkout', function() {
                    checkout.find('.checkout__shipping-method-table').block({
                        message: null,
                        overlayCSS: wntrTheme.overlayCss
                    });
                });

                wntrTheme.body.on('updated_cart_totals updated_checkout', function() {
                    checkIfCanChooseShippingMethod();

                    checkout.find('.checkout__shipping-method-table').unblock();

                    // Only show first 10 options for UPS access points
                    checkout.find('#ups_access_point option').each(function(index) {
                        if(index > 10) {
                            $(this).remove();
                        }
                    });
                });

                // Change quantity
                wntrTheme.body.on('change', '.product-quantity select, .product-quantity input', function(e) {
                    e.preventDefault();

                    // Klarna already has functionality for this.
                    if($(this).closest('#kco-order-review').length > 0) {
                        return;
                    }

                    const data = {
                        action: 'update_order_cart',
                        security: wc_checkout_params.update_order_cart_nonce,
                        cart_item: $(this).data('cart-item-key'),
                        qty: parseInt($(this).val())
                    };

                    $.ajax({
                        type: 'POST',
                        url: vont['ajax-url'],
                        data: data,
                        success: function(response) {
                            checkout.find('.woocommerce-checkout-review-order-table').unblock();

                            if(response === 'error') {
                                checkout.find('.checkout-outer-wrapper').block({
                                    message: null,
                                    overlayCSS: wntrTheme.overlayCss
                                });

                                window.location.replace(vont['cart-url']);
                            } else {
                                $(document.body).trigger('update_checkout');
                            }
                        },
                        dataType: 'html'
                    });
                });

                // Custom coupon form through ajax
                wntrTheme.body.on('keypress', '#woocommerce-coupon-form input', function(e) {
                    const keycode = (e.keyCode ? e.keyCode : e.which);
                    if(keycode === '13') {
                        e.preventDefault();
                        $(this).closest('#woocommerce-coupon-form').find('button').trigger('click');
                    }
                });
                wntrTheme.body.on('click', '#woocommerce-coupon-form button', function() {
                    // Stolen directly from WooCommerce's checkout.js
                    const $form = $(this).closest('#woocommerce-coupon-form');

                    if($form.is('.processing')) {
                        return false;
                    }

                    $form.addClass('processing');

                    checkout.find('#order_review').block({
                        message: null,
                        overlayCSS: wntrTheme.overlayCss
                    });

                    const data = {
                        security: wc_checkout_params.apply_coupon_nonce,
                        coupon_code: $form.find('input[name="coupon_code"]').val()
                    };

                    $.ajax({
                        type: 'POST',
                        url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
                        data: data,
                        success: function(code) {
                            $('.woocommerce-error, .woocommerce-message').remove();
                            $form.removeClass('processing');
                            checkout.find('#order_review').unblock();

                            if(code) {
                                $form.before(code);
                                $form.slideUp();

                                $(document.body).trigger('update_checkout', { update_shipping_method: false });
                            }
                        },
                        dataType: 'html'
                    });
                });
            }
        }
    };

    $(".variation-radios input").click(function() {
        $(".custom-product-qty input:first").attr('checked', true);
        $('.single_add_to_cart_button').prop("disabled", false);
        const firstValue = $(".custom-product-qty input:first").val();
        $('.qty').val(firstValue);
    });

    $(document).ready(wntrTheme.init);
})(jQuery);
